export default {
  title: 'Control Tower',

  // Estados de pantalla
  idle_title: 'You have not run any searches',
  idle_subtitle: 'Here you will see the tasks that have been assigned',
  idle_action: 'Search tasks',
  loading_title: 'Loading results...',
  loading_subtitle: 'We are building your board.',
  empty_title: 'No results',
  empty_subtitle: 'No task matches the applied filters.',
  empty_action: 'Clear filters',
  error_title: 'We could not load the board',
  error_subtitle: 'Try again. If it keeps failing, let the team know.',
  error_action: 'Retry',

  // Barra de herramientas
  select_many: 'Select several',
  download: 'Download',
  new_task: 'New Task',
  view_kanban: 'Board view',
  view_list: 'List view',
  edit_columns: 'Customize columns',
  edit: 'Edit',
  reassign: 'Reassign',
  delete: 'Delete',

  // Catálogos de filtro (el texto visible siempre sale de aquí)
  origin_form: 'Forms',
  origin_task: 'Tasks',
  origin_quick_review: 'Quick reviews',
  origin_sprint: 'Sprints',
  origin_resource: 'Resources',
  origin_routine: 'Routines',
  priority_low: 'Low',
  priority_medium: 'Medium',
  priority_high: 'High',
  sort_end_date: 'Due date',
  sort_title: 'Title',

  // Columnas de la vista de lista
  column_state: 'Status',
  column_title: 'Title',
  column_origin: 'Source',
  column_evidences: 'Evidence',
  column_assignee: 'Assignee',
  column_location: 'Location',
  column_end_date: 'Due Date',
  column_priority: 'Priority',
  column_region: 'Region',
  column_zone: 'Zone',
  column_district: 'District',
  column_created_by: 'Created by',
  column_tag: 'Category',
  column_tag2: 'Area',

  // Filtros
  filter: 'FILTER',
  filter_type: 'Filter type',
  by_status: 'By Status',
  by_user: 'By User',
  by_location: 'By Location',
  my_filters: 'My Filters',
  filter_name: 'Filter name',
  save_filter: 'Save filter',
  save_filter_confirm: 'Save this filter?',
  overwrite_filter_confirm: 'A filter with that name already exists. If you overwrite it you cannot recover the previous one.',
  rename_filter: 'Rename',
  delete_filter: 'Delete filter',
  clear_filters: 'Delete filter',
  apply: 'Apply',
  responsible: 'Assignee',
  search_responsible: 'Search an assignee',
  location: 'Location',
  search_location: 'Search a location',
  priority: 'Priority',
  tag: 'Tag',
  origin: 'Source',
  status: 'Status',
  period: 'Period',
  start_date: 'From',
  end_date: 'To',
  sort: 'Sort',
  sort_add: 'Add',
  category: 'Category',
  area: 'Area',
  search: 'Search',
  you: '(You)',

  // Columnas del tablero
  pin_status: 'Pin Status',
  pin_user: 'Pin User',
  pin_location: 'Pin Location',
  send_to_end: 'Send to the end',
  swap_with: 'Swap position with…',
  columns_prev: 'Previous columns',
  columns_next: 'Next columns',
  column_menu: 'Column menu',
  change_state: 'Change status',
  task_state_in_progress: 'In progress',
  task_state_overdue: 'Overdue',
  task_state_suspended: 'Suspended',
  task_state_finished: 'Finished',
  toast_move_failed: 'The task could not be moved',
  totals: 'Total',
  overdue: 'Overdue',
  in_progress: 'In progress',
  finished: 'Finished',
  suspended: 'Suspended',
  escalated: 'Escalated',
  load_more: 'Load more',

  // Tarjeta
  evidences: 'Evidence',
  evidences_count: '{count} Evidence',

  // Acciones masivas
  delete_dialog_title: 'Delete these tasks?',
  delete_dialog_text: 'Once deleted you cannot recover them.',
  delete_confirm: 'Delete',
  cancel: 'Cancel',
  reassign_dialog_title: 'Who do you want to reassign these tasks to?',
  reassign_dialog_text: 'These tasks will be sent to the selected user.',
  reassign_confirm: 'Reassign',
  reassign_cross_location: 'This user has a different location, please reassign to a user with the same location.',
  edit_dialog_title: 'Select an item to edit.',
  edit_dialog_text: 'The following information will be edited in every selected task.',
  edit_field: 'Select...',
  edit_value: 'Select...',
  field_priority: 'Priority',
  field_assignee: 'Assignee',
  field_state: 'Status',
  field_evidence: 'Photo required',
  field_tags: 'Tags',
  evidence_required: 'Require photo',
  evidence_not_required: 'Photo not required',
  save_changes: 'Save changes',
  save: 'Save',

  // Descargas
  download_pdf: 'PDF',
  download_excel: 'Excel (.xlsx)',
  download_csv: '.csv',
  columns_dialog_title: 'Select the items to include in your table',
  columns_dialog_select: 'Customize the columns',
  download_full_table: 'Download full table',
  document_dialog_title: 'Select the items to include in your document',
  default_view: 'See the default view',

  // Reporte
  report_title: 'Control Tower Report',
  report_compliance: 'Task compliance',
  report_filters: 'Applied filters',
  report_users: 'Users',
  report_filters_detailed: 'Detailed filters',
  report_created_with: 'Created with',
  report_date_of: 'Date from',
  report_date_to: 'to',
  report_date: 'Date',
  report_location: 'Location',
  report_evidences: '{count} evidences',
  report_evidences_one: '1 evidence',
  report_empty_group: 'No tasks in this group',
  report_no_data: 'No tasks to chart',

  // Avisos
  toast_pinned: 'Column pinned to the start',
  toast_pinned_status: 'Status pinned successfully.',
  toast_pinned_user: 'User pinned successfully.',
  toast_pinned_location: 'Location pinned successfully.',
  toast_sent_to_end: 'Column sent to the end',
  toast_swapped: 'Columns swapped',
  toast_task_created: 'Task created successfully.',
  toast_deleted: 'Tasks deleted successfully.',
  toast_reassigned: 'Reassignment completed successfully',
  toast_updated: 'The changes have been saved successfully',
  toast_filter_saved: 'Filter saved successfully',
  toast_downloaded: 'Download completed successfully.',
  toast_columns_saved: 'Columns updated',

  // Detalle y alta de tarea
  detail_conversation: 'Conversation',
  detail_read_only: 'Read only',
  detail_assigned_by: 'Assigned by',
  detail_photo_required: '*Photo required',
  detail_no_comments: 'No messages on this task yet.',
  detail_write_comment: 'Write a comment',
  send: 'Send',
  detail_comment_error: 'The comment could not be saved.',
  detail_comment_closed: 'This task is closed: comments are disabled.',
  detail_reassigned_to: 'Reassigned to {user}',
  create: 'Create',
  field_title: 'Title',
  field_description: 'Description...',
  field_photo: 'Photo',
  field_due_date: 'Due date',
  field_assignees: 'Assignees (max. {max})',
  field_readers_toggle: 'Add reader',
  field_users_placeholder: 'User(s)',
  location_selected_single: '{name} has been selected as the location. Click here to change the location.',
  date_placeholder: '----/----/--------',
  field_readers: 'Readers (max. {max})',
  max_assignees: 'Maximum {max} assignees',
  max_readers: 'Maximum {max} readers',
  approval_notice: 'When finished, this task will require approval from whoever created it.',
  toast_task_created_many: '{count} tasks created successfully',
  detail_task: 'Task',
  detail_origin: 'Source:',
  detail_tags: 'Tags',
  detail_see_more: 'See more',

  // Nueva tarea
  new_task_single: 'One task',
  new_task_multiple: 'Multiple locations',

  // New task (Figma design) and dialog notices (Block D)
  field_title_placeholder: 'Task title...',
  field_require_photo: 'Require photo',
  field_responsible: 'Select a person in charge',
  locations_title: 'Locations',
  locations_none: 'No location has been selected.',
  locations_selected: '{count} location(s) selected',
  accept: 'Accept',
  reassign_error_title: 'Cannot reassign to this user.',
  close_notice: 'Close',
  reassign_error_generic: 'The action could not be completed. Please try again.',
  edit_error_title: 'Changes could not be saved',
  list_focus_empty: 'There are no tasks for this indicator.',

  // Filters panel (Block C)
  filter_all: 'All',
  filter_no_options: 'No results',
  clear_selection: 'Clear selection',
  tags: 'Tags',
  site: 'Site',
  subcategory: 'Subcategory',
  date: 'Date',
  search_origin: 'Search an origin',
  clear_all_filters: 'Clear all filters',
  show_tasks: 'Show Tasks',
  confirm_name: 'Save name',
  preset: 'Filter',
  apply_preset: 'Apply this filter',
  save_preset: 'Save filters in this slot',
  preset_needs_filters: 'Select the filters you want to save first.',
  preset_name_taken: 'You already have a filter with that name.',
  preset_save_error: 'The filter could not be saved. Please try again.',
  save_preset_title: 'Do you want to save this filter?',
  save_preset_text: 'The filled-in data will be saved in this slot.',
  overwrite_title: 'Do you want to overwrite this filter?',
  overwrite_text: 'Saving a new filter will erase the previous one and it cannot be recovered.',
  delete_preset_title: 'Do you want to delete this filter?',
  delete_preset_text: 'Once deleted you will not be able to recover it.',
  sort_title_dialog: 'Select the sorting',
  sort_by: 'Sort by:',
  sort_confirm: 'Sort',
  sort_asc: 'Ascending',
  sort_desc: 'Descending',
  sort_remove: 'Remove this sort',
  sort_add_filter: 'Add filter',
  sort_delete_filter: 'Delete filter',
  date_start: 'Start',
  date_end: 'End',
  origin_of_task: 'Task origin',
  select_option: 'Select',
  close: 'Close',
  results_with_filters: 'Results of your search with Filters'
}
